export default "__VITE_ASSET__DLMMJZVw__"